import { first } from "rxjs/operators";
import { MsgService, Msg } from "@app/_components/msg";
import * as moment from "moment";
import {
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MsgComponent } from "../msg/msg.component";
import { Component, Input, OnInit } from "@angular/core";
import { AlertService } from "@app/_services";
import {
  LazyLoadEvent,
  MessageService,
  ConfirmationService,
} from "primeng/api";
import {SendFullMailComponent} from '@app/_components/msg/send-full-mail/send-full-mail.component';
import {MsgHistoryComponent} from '@app/_components/msg/msg-history/msg-history.component';

@Component({
    selector: "app-msg-list",
    templateUrl: "./msg-list.component.html",
    styleUrls: ["./msg-list.component.css"],
    providers: [
        MessageService,
        ConfirmationService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ],
    // make column heading sticky
    styles: [
        `
      :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
        position: -webkit-sticky;
        position: sticky;
        top: 0px;
      }

      @media screen and (max-width: 64em) {
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
          top: 99px;
        }
      }
    `,
    ],
    standalone: false
})
export class MsgListComponent implements OnInit {
  constructor(
    private msgService: MsgService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dialog: MatDialog
  ) {
    this.statuses = msgService.statuses;
    this.msgTopics = msgService.msgTopics;
    this.msgTopicPurposes = msgService.msgTopicPurposes;
    this.msgEvents = msgService.msgEvents;
    this.statusesForFilter.push.apply(this.statusesForFilter, this.statuses);
    this.dateNow = moment(new Date()).toDate();
  }

  // data
  @Input() showFilter = true;
  @Input() showPagination = true;
  @Input() outlineNewButton = true;
  @Input() msgCampaignId: any;
  @Input() reservationId: any;
  @Input() listUpdated: false;
  @Input() isCompactList: false;

  msgs: any;
  msg: Msg;
  selectedMsgEvent: any;
  msgTopics: any[];
  msgTopicPurposes: any[];
  // paging
  first = 0;
  rows = 50;

  // list
  datasource: any;

  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];

  // forms
  formLoading = false;

  statuses: any;
  statusesForFilter = [{ value: null, name: 'All' }];
  msgEvents = [];
  dateNow: any;

  msgOriginOptions: any[] = [
    { label: 'All', value: null },
    { label: 'Email', value: 6 },
    { label: 'Admin Email', value: 1 },
    { label: 'SMS', value: 2 },
    { label: 'Call', value: 3 },
    { label: 'OTA', value: 4 },
    { label: 'Portal', value: 5 },
    { label: 'Note', value: 7 },
  ];
  selectedMsgOrigin: number | null = null;

  columns: any[] = [
    { field: 'msgId', header: 'Id', width: 'auto' },
    { field: 'status', header: 'Status', width: '350px' },
    { field: 'event', header: 'Event', width: '350px' },
    { field: 'msgOrigin', header: 'Origin', width: '120px' },
    { field: 'recipients', header: 'Recipient Name', width: '380px' },
    { field: 'msgRecipientVOList.email', header: 'Recipient Email', width: '480px' },
    { field: 'msgRecipientVOList.mobileNum', header: 'Phone', width: '180px' },
    { field: 'receivedDate', header: 'Received Date', width: 'auto' },
    { field: 'subject', header: 'Subject', width: 'auto' },
    { field: 'senderName', header: 'Sender Name', width: 'auto' },
    { field: 'senderEmail', header: 'Sender Email', width: 'auto' },
    { field: 'sentDate', header: 'Sent Date', width: 'auto' },
    { field: 'topic', header: 'Topic', width: 'auto' },
    { field: 'topicId', header: 'TopicId', width: 'auto' },
    { field: 'topicPurpose', header: 'topicPurpose', width: 'auto' }
  ];

  columnsWithCompactList: any[] = [
    { field: 'msgId', header: 'Id', width: 'auto' },
    { field: 'status', header: 'Status', width: '350px' },
    { field: 'event', header: 'Event', width: '350px' },
    { field: 'msgOrigin', header: 'Origin', width: '120px' },
    { field: 'recipients', header: 'Recipient Name', width: 'auto' },
    { field: 'msgRecipientVOList.email', header: 'Recipient Email', width: 'auto' },
    { field: 'receivedDate', header: 'Received Date', width: 'auto' },
    { field: 'subject', header: 'Subject', width: 'auto' },
    { field: 'sentDate', header: 'Sent Date', width: 'auto' },
  ];

  ngOnInit(): void {
    try {
      // default sort of list
      this.multiSortMeta = [];
      this.multiSortMeta.push({ field: "createDate", order: 0 });
    } catch (error) {
      console.log("Error: " + error);
    }
  }
  ngOnChanges() {
    this.ngOnInit();
  }

  /*********
   * Delete Button
   *
   */
  onRowDelete(event: any) {
    console.log("onRowDelete: " + JSON.stringify(event));
    this.confirmationService.confirm({
      message: "Are you sure you want to delete Id# " + event.msgId + "?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.formDelete(event);
      },
      reject: () => {
        this.messageService.add({
          severity: "info",
          summary: "Canceled",
          detail: "Delete canceled.",
          life: 3000,
        });
      },
    });
  }

  /*********
   * Lazy Load All Data
   *
   */
  loadLazy(event: LazyLoadEvent) {
    try {
      this.loading = true;
      this.lazyLoadEvent = event;
      console.log(
        " event.first:" +
          event.first +
          "  |  event.rows:" +
          event.rows +
          "  |  event.sortField:" +
          event.sortField +
          "  |  event.sortOrder:" +
          event.sortOrder +
          "  |  event.multiSortMeta:" +
          JSON.stringify(event.multiSortMeta) +
          "  |  event.globalFilter:" +
          event.globalFilter +
          "  |  event.filters:" +
          JSON.stringify(event.filters)
      );

      /*
       *
       * Default Sort
       */
      // https://stackoverflow.com/questions/679915/how-do-i-msg-for-an-empty-javascript-object
      // if we are NOT filtering and we are NOT sorting, apply a default sort
      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: "createDate", order: -1 });
      }

      const pageNumber = Math.round(event.first / event.rows);
      if ( this.msgCampaignId){
        let msgCampaignIdFilter = { 'msgCampaignVO.msgCampaignId': { 'value': this.msgCampaignId, 'matchMode': 'in' } };
        Object.assign(event.filters, msgCampaignIdFilter);
      }
      if ( this.reservationId){
        let reservationIdFilter = { 'reservationVO.reservationId': { 'value': this.reservationId, 'matchMode': 'in' } };
        Object.assign(event.filters, reservationIdFilter);
      }
      this.msgService
        .findByFilter(
          pageNumber,
          event.rows,
          event.sortField,
          event.sortOrder,
          event.multiSortMeta,
          event.globalFilter,
          event.filters,
          this.selectedMsgEvent
        )
        .pipe(first())
        .subscribe(
          (res: any) => {
            this.datasource = res.data.reviews;
            this.recordTotal = res.page.recordTotal;
            this.msgs = res.data.msgs;
            console.log(JSON.stringify(res.page));
          },
          (err: any) => {
            console.log("reviews list error!: " + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => {
            this.loading = false;
          }
        );

      if (this.datasource) {
        this.msgs = this.datasource.slice(
          event.first,
          event.first + event.rows
        );
      }
    } catch (error) {
      console.log("loadLazy(" + event + ")" + error);
    }
  }

  getStatus() {
    return;
  }

  /*********
   * onRowSelect()
   * Used to handle row click (to edit, link, etc)
   */
  onRowSelect(event: any) {
    console.log("onRowSelect: " + JSON.stringify(event));
    this.onOpenFormEdit(event.data);
  }

  // handled in rate-bucket-form
  formAdd() {}

  /*********
   * formUpdate()
   * Used for row editing
   */
  formUpdate(msg: Msg) {
    try {
      this.formLoading = true;
      this.msgService.update(msg).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Update SUCCESS: " + JSON.stringify(res));
          this.msgs.map((msg, i) => {
            if (msg.msgId === res.data.msg.msgId) {
              this.msgs[i] = res.data.msg;
            }
          });
          // this.alertService.success(res, true);
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Update FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: JSON.stringify(err),
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * formDelete()
   * Used for row editing
   */
  formDelete(msg: any) {
    try {
      // stop here if form is invalid
      console.log("Delete Submitted: " + JSON.stringify(msg));

      this.formLoading = true;
      this.msgService.delete(msg.msgId).subscribe(
        (res: any) => {
          console.log("Rate-Bucket-Delete SUCCESS: " + JSON.stringify(res));
          this.msgs.splice(this.msgs.indexOf(msg), 1);
          this.recordTotal = this.msgs.length;
          this.messageService.add({
            severity: "success",
            summary: "Successful",
            detail: "Msg " + msg.msgId + " Deleted",
            life: 3000,
          });
        },
        (err: any) => {
          console.log("Rate-Bucket-Delete  FAIL: " + JSON.stringify(err));
          this.messageService.add({
            severity: "error",
            summary: "Delete Failed",
            detail:
              "Msg " +
              msg.msgId +
              " could not be deleted.  Be sure there are no assigned properties to this bucket.",
            life: 3000,
          });
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      console.log("Form Invalid: " + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  /*********
   * Add New Button
   *
   */
  onOpenFormAdd() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: "Add Message",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(MsgComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.addMsgCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }
  sendFullMail() {
    const dialogConfig = new MatDialogConfig();
    this.msg = new Msg();
    this.msg.subject = 'test subject from input';
    this.msg.emailHtml = 'this is test mail content html';
    this.msg.topicId = 0;
    this.msg.topic = 900; // 'custom mail'

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'send mail',
      msg: this.msg,
      toEmails: '',
      ccEmails: '',
      bccEmails: ''
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(SendFullMailComponent, dialogConfig);

    dialogRef.componentInstance.doAdd.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.addMsgCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /*********
   * Edit Button
   *
   */
  onOpenFormEdit(msg: Msg) {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      msg: msg,
      title: "Edit Msg",
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(MsgComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.updateMsgCB(data);

      // close the dialogBox
      dialogRef.close();
    });

    dialogRef.componentInstance.doDelete.subscribe((data) => {
      console.log("Dialog output:", data);

      // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
      this.deleteMsgCB(data);

      // close the dialogBox
      dialogRef.close();
    });
  }

  /**
   *
   * Dialog from Form Callbacks
   * To edit the list show add/edit/delete in real time from the popup form
   *
   */
  addMsgCB(msg: Msg) {
    console.log("Adding Msg: " + JSON.stringify(msg));
    // if we don't have a msgs array yet...
    if (!this.msgs) {
      this.msgs = [];
    }
    // unshift adds to the front of the array (), push adds to the back
    this.msgs.unshift(msg);

    // no idea what this is but it is required to update the array
    this.msgs = [...this.msgs];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "Msg " + msg.msgId + " Added",
      life: 3000,
    });
  }

  updateMsgCB(msg: Msg) {
    console.log("Updating Msg: " + JSON.stringify(msg));
    let itemIndex = this.msgs.findIndex(
      (item: any) => item.msgId === msg.msgId
    );
    this.msgs[itemIndex] = msg;

    // no idea what this is but it is required to update the array
    this.msgs = [...this.msgs];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "Msg " + msg.msgId + " Updated",
      life: 3000,
    });
  }

  deleteMsgCB(msg: Msg) {
    console.log("Removing Msg: " + msg);
    this.msgs.splice(this.msgs.indexOf(msg), 1);
    this.recordTotal = this.msgs.length;

    // no idea what this is but it is required to update the array
    this.msgs = [...this.msgs];

    this.messageService.add({
      severity: "success",
      summary: "Success",
      detail: "Msg " + msg.msgId + " Deleted",
      life: 3000,
    });
  }

  /**********
   *
   * PAGINATOR FUNCTIONS
   */
  next() {
    this.first = this.first + this.rows;
  }
  prev() {
    this.first = this.first - this.rows;
  }
  reset() {
    this.first = 0;
  }
  isLastPage(): boolean {
    return this.msgs ? this.first === this.msgs.length - this.rows : true;
  }
  isFirstPage(): boolean {
    return this.msgs ? this.first === 0 : true;
  }

  get Statuses() {
    return this.statuses;
  }

  getStatusName(msg: any) {
    if (msg?.status) {
      const status = this.statuses.find((e: any) => e.value == msg.status);
      return status.name;
    } else {
      return '';
    }
  }
  getTopicName(msg: any) {
    if (msg?.topic) {
      const top = this.msgTopics.find((e: any) => e.value == msg.topic);
      return top?.name;
    } else {
      return '';
    }
  }
  getTopicPurpose(msg: any) {
    if (msg?.topicPurpose) {
      const top = this.msgTopicPurposes.find((e: any) => e.value === msg.topicPurpose);
      return top.name;
    } else {
      return '';
    }
  }
  originLabel(origin: number): string {
    switch (origin) {
      case 1: return 'Admin Email';
      case 2: return 'SMS';
      case 3: return 'Call';
      case 4: return 'OTA';
      case 5: return 'Portal';
      case 6: return 'Email';
      case 7: return 'Note';
      default: return origin != null ? `Origin ${origin}` : '—';
    }
  }

  onOriginFilterChange(value: number | null) {
    this.selectedMsgOrigin = value;
    if (this.lazyLoadEvent) {
      if (value != null) {
        Object.assign(this.lazyLoadEvent.filters, { msgOrigin: { value, matchMode: 'in' } });
      } else {
        delete this.lazyLoadEvent.filters['msgOrigin'];
      }
      this.loadLazy(this.lazyLoadEvent);
    }
  }

  reloadPage() {
    window.location.reload();
  }

  loadMyInbox() {

    try {
      this.loading = true;
      let event = this.lazyLoadEvent;

      /*
       *
       * Default Sort
       */
      // https://stackoverflow.com/questions/679915/how-do-i-msg-for-an-empty-javascript-object
      // if we are NOT filtering and we are NOT sorting, apply a default sort
      if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: "createDate", order: -1 });
      }

      const pageNumber = Math.round(event.first / event.rows);
      let myMailBoxFilter = {
        'status': { 'value': 3, 'matchMode': 'in' }};
      Object.assign(event.filters, myMailBoxFilter);

      let myMailBoxFilter1 = {
        'userId': { 'value': 108852, 'matchMode': 'in' }};
      Object.assign(event.filters, myMailBoxFilter1);

      this.msgService
          .findByFilter(
              pageNumber,
              event.rows,
              event.sortField,
              event.sortOrder,
              event.multiSortMeta,
              event.globalFilter,
              event.filters,
            null
          )
          .pipe(first())
          .subscribe(
              (res: any) => {
                this.datasource = res.data.reviews;
                this.recordTotal = res.page.recordTotal;
                this.msgs = res.data.msgs;
                console.log(JSON.stringify(res.page));
              },
              (err: any) => {
                console.log("reviews list error!: " + JSON.stringify(err));
                this.alertService.error(err);
              },
              () => {
                this.loading = false;
              }
          );

      if (this.datasource) {
        this.msgs = this.datasource.slice(
            event.first,
            event.first + event.rows
        );
      }
    } catch (error) {
      console.log("loadLazy(" + event + ")" + error);
    }
  }

  showPaginator() {
    return true;
  }

    seeConversation() {
      const dialogRef = this.dialog.open(MsgHistoryComponent, null);
      dialogRef.componentInstance.doAdd.subscribe((data) => {
        dialogRef.close();
      });
    }
}
